import { setRangeMax } from './helpers';
import { FOfferType, TJsonQuery } from './types';
import { offerTypeFromJsonQuery } from './utils/offerTypeFromJsonQuery';

export const setTotalAreaMax =
  (jsonQuery: TJsonQuery) =>
  (lte: number | null): TJsonQuery => {
    const offerType = offerTypeFromJsonQuery(jsonQuery);
    const field = (offerType & FOfferType.CommercialLand) !== 0 ? 'site' : 'total_area';

    return setRangeMax(field)(jsonQuery)(lte);
  };
